import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import useAuthStore from "../stores/authStore";
import { useCurrentUserQuery } from "../hooks/queries/useAuthQueries";
import { Loader } from "@mantine/core";
import { useEffect } from "react";

function ProtectedRoute({ allowedRoles = [], children }) {
  const {
    isAuthenticated,
    user: tokenUser,
    computedUser,
    clearAuth,
  } = useAuthStore();

  const { isLoading, isError } = useCurrentUserQuery();

  useEffect(() => {
    if (isError) {
      clearAuth();
    }
  }, [isError, clearAuth]);

  if (!isAuthenticated || (!tokenUser && !computedUser)) {
    return <Navigate to="/auth/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader color="blue" />
      </div>
    );
  }
  if (isError) {
    return <Navigate to="/auth/login" replace />;
  }

  const user = computedUser || tokenUser;

  const hasRole =
    Array.isArray(user?.roles) &&
    allowedRoles.some((r) => user.roles.includes(r));

  if (!user || !hasRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
